import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { PatientResponse } from 'src/app/services/stellair/model/patientResponse';
import { environment } from 'src/environments/environment';

interface PatientVc {
  id: string;
  nom: string;
  prenom: string;
  dateNaissance: string;
}

@Component({
  selector: 'app-stellair-select-patient-cv',
  templateUrl: './stellair-select-patient-cv.component.html',
  styleUrls: [
    './stellair-select-patient-cv.component.scss',
    '../modal.fragment.scss'
  ]
})
export class StellairSelectPatientCvComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  @Output() public closeEmitter = new EventEmitter<string | undefined>();

  public patientVcArr: Array<PatientResponse>;
  public patientVcArrTmpl: Array<PatientVc> = [];

  constructor() { }

  ngOnInit(): void {
    this._initData();
  }

  public closeModal(infos?: string) {
    this.closeEmitter.emit(infos);
  }

  public onSubmit(patient?: PatientVc) {
    this.closeModal(patient?.id);
  }

  private _initData() {
    if (this.patientVcArr) {
      for (const patient of this.patientVcArr) {
        this.patientVcArrTmpl.push({
          id: patient.id,
          nom: patient.donneesPatient.CV.donneesAmo.nom,
          prenom: patient.donneesPatient.CV.donneesAmo.prenom,
          dateNaissance: patient.donneesPatient.CV.donneesAmo.dateNaissanceStr,
        });
      }
    }
  }

}
